import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { classNames } from '../utils';

function Select({
  className,
  label,
  options,
  hideLabel = false,
  placeholder,
  placeholderClickable = false,
  value,
  onChange,
  rounded = true
}) {
  const id = useId();

  return (
    <div
      className={classNames('select', rounded && 'select--rounded', className)}
    >
      <label
        className={classNames('select__label', hideLabel && 'sr-only')}
        htmlFor={`select-${id}`}
      >
        {label}
      </label>
      <select
        className="select__select"
        id={`select-${id}`}
        value={value || (placeholder ? '' : options[0].Value)}
        onChange={(e) => onChange(e.target.value)}
      >
        {placeholder ? (
          <option value="" disabled={!placeholderClickable} hidden={!placeholderClickable}>
            {placeholder}
          </option>
        ) : null}
        {options.map((option) => (
          <option key={option.Value} value={option.Value}>
            {option.Label}
          </option>
        ))}
      </select>
    </div>
  );
}

Select.propTypes = {
  className: PropTypes.string,
  hideLabel: PropTypes.bool,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      Label: PropTypes.string.isRequired,
      Value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  rounded: PropTypes.bool,
  placeholderClickable: PropTypes.bool
};

export default Select;
